export default "/_next/static/images/BGEraser-c70e2b9c49cd73c96bf9f336114f88c9.png";